<uilab-icon class="ui-search__prefix-icon" icon="action--search"></uilab-icon>
<ng-content></ng-content>
@if (hasContent) {
  <uilab-icon-button
    aria-label="Clear"
    title="Clear"
    class="ui-search__suffix-icon"
    (click)="resetForm()"
    >
    <uilab-icon slot="icon" icon="action--close"> </uilab-icon>
  </uilab-icon-button>
}
